import React, { useEffect, useMemo, useState } from 'react'

import styles from "./index.module.scss";
import Digit from './components/Digit';
import moment from 'moment';
import _ from 'lodash';

export default function DigitalTimer({ start_date = null, end_date = null, onTimeEnd = () => { } }) {
    const INITIAL_TIMER_PAYLOAD = useMemo(() => {
        return {
            seconds: 0,
            minutes: 0,
            hours: 0,
            days: 0
        }
    }, [])
    const [timer, setTimer] = useState(getTimerData())

    useEffect(() => {
        const interval = setInterval(() => {
            const newTimer = getTimerData()

            if (!newTimer.seconds && !newTimer.minutes && !newTimer.hours && !newTimer.days) {
                onTimeEnd()
            }
            else {
                setTimer(prev => {
                    return {
                        ...prev,
                        ...newTimer
                    }
                });
            }
        }, 1000);

        return () => clearInterval(interval);
    }, []);


    function getTimerData() {
        const payload = { ...INITIAL_TIMER_PAYLOAD };
        const startDate = moment(start_date || new Date())
        const endDate = moment(end_date || new Date())
        const duration = moment.duration(endDate.diff(startDate))
        const { seconds, minutes, hours, days } = duration._data

        payload.seconds = seconds
        payload.minutes = minutes
        payload.hours = hours
        payload.days = days
        return payload;
    }

    return (
        <div className={styles.TimerContainer}>
            <Digit value={timer.days} title={'Days'} isFullSize={true} />
            <Digit value={timer.hours} title={'Hours'} />
            <div className={`${styles.separatorContainer} fw-bold`}> <div className={styles.separator} > : </div>  </div>
            <Digit value={timer.minutes} title={'Minutes'} addSeparator />
            <div className={`${styles.separatorContainer} fw-bold`}> <div className={styles.separator} > : </div>  </div>
            <Digit value={timer.seconds} title={'Seconds'} />
        </div>
    )
}
